import React, { Component } from "react";
import { PageHeader, PageBody, ProjectHome } from "../components";
import { API_MAIN } from "../utils/api";
import axios from "axios";
import bg_our_service from "../assets/images/pageHeader/img-career-header.jpg";

export class Thank extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: [],
      main: [],
    };
  }

  componentDidMount() {
    const headers = {};
    axios
      .get(API_MAIN, { headers: headers })
      .then((res) => {
        const content = res.data.main.VISI;
        const main = res.data.main;
        this.setState({ main });
        this.setState({ content });
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  render() {
    const { content, main } = this.state;
    const header = {
      title: main.Questionnaire,
      subtitle: main.Questionnaire,
      breadcrumb: main.Questionnaire,
      bg_image: bg_our_service,
    };
    return (
      <main>
        <div role="main" className="main">
          <PageHeader param={header} />
          <div className="container py-2">
            <div className="row">
              <div className="col-lg-12 pl-0">
                <h1
                  style={{ textAlign: "center", margin: "100px auto" }}
                  align="justify"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: main.thank,
                    }}
                  ></div>
                </h1>
              </div>
            </div>
          </div>
          <ProjectHome />
          <hr className="solid tall mt-5" />
        </div>
      </main>
    );
  }
}

export default Thank;
